import type { SVGProps } from 'react';

const SvgPageLastHorizontally = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M6.71 3.29A.996.996 0 1 0 5.3 4.7l7.29 7.29-7.29 7.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l8-8a.996.996 0 0 0 0-1.41zM17 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1"
    />
  </svg>
);
export default SvgPageLastHorizontally;
